import React from 'react';
import PeopleData from '../../services/people-service';
import SociogramService from '../../services/socio-service';
import './sociogram.css';
import toast from 'react-hot-toast';

export class CreateSociogramForm extends React.Component {

  constructor() {
    super()
    this.state = {}
  }

  async componentDidMount() {
    const { accessToken } = this.props;
    this.setState({
      accessToken
    })
    const data = await PeopleData.getData(accessToken);
    this.setState({ 
      data: data 
    });
  }

  peopleList = {};
  includedPeople = [];

  handlePersonCheck = event => {
    if( event.target.checked )
      this.includedPeople.push(event.target.name);
    else{
      var index = this.includedPeople.indexOf(event.target.name);
      this.includedPeople.splice(index, 1);
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      // Get form data
      const data = new FormData(event.target);
      const formData = {
        name: data.get('name'),
        password: data.get('password'),
        people: this.includedPeople
      };
      
      // Use access token from state
      const { accessToken } = this.state;
      
      // Call the updated createSociogram method
      await SociogramService.createSociogram(formData, accessToken);
      
      // Handle success
      toast.success('Successfully created Sociogram');
      
      // Clear form if successful
      document.getElementById("create-sociogram").reset();
      
    } catch (error) {
      // Handle error
      toast.error(error.message);
      console.error("Error creating sociogram:", error);
    }
  }

  selectAll = event => {
    for( var i = 0; i < this.state.data.length; i++){
      this.includedPeople.push(this.state.data[i].id);
    }
    this.toggleCheckboxes(true);
  }

  deselectAll = event => {
    this.toggleCheckboxes(false);
    for( var i = 0; i < this.state.data.length; i++){
      var index = this.includedPeople.indexOf(this.state.data[i].id);
      this.includedPeople.splice(index, 1);
    }
  }

  toggleCheckboxes(select){
    var x = document.getElementsByClassName("checkbox");
    for(var i = 0; i < x.length; i++) {
      x[i].checked = select;
    }
    return false;
  }

  render() {

    let userRows = [];

    if( !this.state.data )
        return (<div>You need to set people up before you can create a sociogram</div>);

    for( var i = 0; i < this.state.data.length; i++){
        userRows.push(<div className="col-md-6">
          <input
            type="checkbox"
            className="form-control checkbox"
            id={this.state.data[i].id}
            name={this.state.data[i].id}
            onChange={this.handlePersonCheck}
            />
            {this.state.data[i].givenName} {this.state.data[i].surname}
        </div>)
    }
    return (
      <div>
        <h1>Create New Sociogram</h1>
        <form className="form-horizontal" id="create-sociogram" onSubmit={this.handleSubmit}>
          <div className="form-group padding-10">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                required
                id="name"
                placeholder="Sociogram Name"
                name="name"
              />
            </div>
            <div className="col-md-6">
              <p>
                (Optional) Provide a password for your Sociogram. This will allow you to share a link to allow people to update their preferences:
              </p>
              <input
                type="text"
                className="form-control"
                id="password"
                placeholder="Sociogram Password"
                name="password"
              />
            </div>
            <div className="col-md-6">
              Select people to invite to this sociogram:
              <div className="form-group">
                <div className="col-md-12">
                  <button
                    type="button"
                    onClick={this.selectAll}
                    className="btn btn-primary btn-block contact">
                    Select All
                  </button>
                  <button
                    type="button"
                    onClick={this.deselectAll}
                    className="btn btn-primary btn-block contact">
                    Deselect All
                  </button>
                </div>
              </div>
              {userRows}
            </div>
          </div>
          <div className="form-group">
            <div className="col-md-12">
              <button
                type="submit"
                className="btn btn-primary btn-block contact">
                Create Sociogram
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}


